import axios from 'axios'; //引入axios
//引入qs
// const url = 'http://192.168.0.181:8060/shareholder/'; //后端公共ip和端口g
// const url = 'http://192.168.0.117:8060/shareholder/'; //后端公共ip和端口l
 // const url = 'http://192.168.0.187:8060/shareholder/'; //本地测试
 const url = 'https://sols.cdtg.com.cn:8060/shareholder/'; //正式环境
// const url = 'https://new.cdtg.com.cn/shareholder/'; //测试环境
// const url = 'http://47.75.165.51:8060/shareholder/'; //服务器(每次打包需要把下面的支付部分放开注释,因为测试的没有微信方法,会报错,打包第二次才会成功)
// const cmsurl = 'https://tg.foway.com.cn:81/'
const cmsurl = 'https://www.cdtg.com.cn/';
//根据项目的需求写请求头，在参数后面接着写就好（headers） type默认为服务器,1为cms(php)地址
function axiosPost(inter, params, type) {
	return new Promise((reslove, reject) => {
		let route = url + inter;
		if (type == 1) {
			route = cmsurl + inter
		}
		axios.post(route, params).then(res => {
			reslove(res)
		}).catch(err => {
			reject(err)
		})
	})
}


function axiosform(inter, params) {
	return new Promise((reslove, reject) => {
		let route = url + inter;
		axios.post(route, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(res => {
			reslove(res)
		}).catch(err => {
			reject(err)
		})
	})
}

function plyPay(wxdata, fn) {
	if (typeof WeixinJSBridge == "undefined") {
		if (document.addEventListener) {
			document.addEventListener('WeixinJSBridgeReady', onBridgeReady(), false);
		} else if (document.attachEvent) {
			document.attachEvent('WeixinJSBridgeReady', onBridgeReady());
			document.attachEvent('onWeixinJSBridgeReady', onBridgeReady());
		}
	} else {
		onBridgeReady();
	}
	window.console.log(wxdata, fn)

	function onBridgeReady() {
		// eslint-disable-next-line no-undef
		WeixinJSBridge.invoke(
			'getBrandWCPayRequest', {
				"appId": wxdata.appId, //公众号名称，由商户传入     
				"timeStamp": wxdata.timeStamp, //时间戳，自1970年以来的秒数     
				"nonceStr": wxdata.nonceStr, //随机串     
				"package": wxdata.package,
				"signType": "MD5", //微信签名方式：     
				"paySign": wxdata.paySign //微信签名 
			},
			function(res) {
				window.console.log(res)
				if (res.err_msg == "get_brand_wcpay_request:ok") {
					fn(true)
					// 使用以上方式判断前端返回,微信团队郑重提示：
					//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
				} else {
					fn(false)
				}
			});
	}
}

function compressFile(file) { //文件压缩
	return new Promise(() => {
		var fileObj = file;
		var reader = new FileReader()
		reader.readAsDataURL(fileObj) //转base64
		reader.onload = function(e) {
			var image = new Image() //新建一个img标签（还没嵌入DOM节点)
			image.src = e.target.result
			image.onload = function() {
				var canvas = document.createElement('canvas'), // 新建canvas
					context = canvas.getContext('2d'),
					imageWidth = image.width / 2, //压缩后图片的大小
					imageHeight = image.height / 2,
					data = ''
				canvas.width = imageWidth
				canvas.height = imageHeight
				context.drawImage(image, 0, 0, imageWidth, imageHeight)
				data = canvas.toDataURL('image/jpeg') // 输出压缩后的base64
				var arr = data.split(','),
					mime = arr[0].match(/:(.*?);/)[1], // 转成blob
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				let files = new window.File([new Blob([u8arr], {
					type: mime
				})], fileObj.name, {
					type: fileObj.type
				}) // 转成file					
				//callback(files) // 回调
				window.console.log('files-----', files);
				return files;
			}
		}
	});

}

//导出
export {
	axiosPost,
	axiosform,
	url,
	plyPay,
	compressFile
}
